import * as types from "../../types/travel";
import axios from "axios";

const token = localStorage.getItem("token:key");
const URL = `/api/v1/travel`;

//////////////////////////////////////////////
//////////// Travel Request Forms ////////////
//////////////////////////////////////////////
export const createTRF = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.CREATE_TRF_REQUEST,
        });
        const { data } = await axios.post(`${URL}/arrangement`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.CREATE_TRF,
            payload: data,
        });
        return data.data;
    } catch (error) {
        dispatch({
            type: types.CREATE_TRF_FAIL,
            payload:
                error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const submitTRF = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.SUBMIT_TRF_REQUEST,
        });
        const { data } = await axios.put(`${URL}/arrangement/submit/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.SUBMIT_TRF,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: types.SUBMIT_TRF_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const getTRFs = () => async (dispatch) => {
    try {
        dispatch({
            type: types.GET_TRFS_REQUEST,
        });
        const { data } = await axios.get(`${URL}/arrangement`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.GET_TRFS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: types.GET_TRFS_FAIL,
            payload:
                error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const getTRF = (id) => async (dispatch) => {
    try {
        dispatch({
            type: types.GET_TRF_REQUEST,
        });
        const { data } = await axios.get(`${URL}/arrangement/${id}/single`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.GET_TRF,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: types.GET_TRF_FAIL,
            payload:
                error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const getMineTRFs = () => async (dispatch) => {
    try {
        dispatch({
            type: types.GET_MINE_TRFS_REQUEST,
        });
        const { data } = await axios.get(`${URL}/arrangement/mine`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.GET_MINE_TRFS,
            payload: data,
        });
        return data.data;
    } catch (error) {
        dispatch({
            type: types.GET_MINE_TRFS_FAIL,
            payload:
                error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};


export const getExternalTRFs = () => async (dispatch) => {
    try {
        dispatch({
            type: types.GET_EXTERNAL_TRFS_REQUEST,
        });
        const { data } = await axios.get(`${URL}/arrangement/external`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.GET_EXTERNAL_TRFS,
            payload: data,
        });
        return data.data;
    } catch (error) {
        dispatch({
            type: types.GET_EXTERNAL_TRFS_FAIL,
            payload:
                error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};


export const getInternalTRFs = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.GET_INTERNAL_TRFS_REQUEST,
        });
        const { data } = await axios.get(`${URL}/arrangement/${body}/internal`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.GET_INTERNAL_TRFS,
            payload: data,
        });
        return data.data;
    } catch (error) {
        dispatch({
            type: types.GET_INTERNAL_TRFS_FAIL,
            payload:
                error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const getApprovedTRFs = () => async (dispatch) => {
    try {
        dispatch({
            type: types.GET_APPROVED_TRFS_REQUEST,
        });
        const { data } = await axios.get(`${URL}/arrangement/approved`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.GET_APPROVED_TRFS,
            payload: data,
        });
        return data.data;
    } catch (error) {
        dispatch({
            type: types.GET_APPROVED_TRFS_FAIL,
            payload:
                error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const updateTRF = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.UPDATE_TRF_REQUEST,
        });
        const { data } = await axios.put(`${URL}/arrangement/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.UPDATE_TRF,
            payload: data,
        });
        return data.data;
    } catch (error) {
        dispatch({
            type: types.UPDATE_TRF_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const deleteTRF = (id) => async (dispatch) => {
    try {
        dispatch({
            type: types.DELETE_TRF_REQUEST,
        });
        await axios.delete(`${URL}/arrangement/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.DELETE_TRF,
            payload: id,
        });
    } catch (error) {
        dispatch({
            type: types.DELETE_TRF_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};


export const approveTRF = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.APPROVE_TRF_REQUEST,
        });
        const { data } = await axios.put(`${URL}/arrangement/approve/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.APPROVE_TRF,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: types.APPROVE_TRF_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const rejectTRF = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.REJECT_TRF_REQUEST,
        });
        const { data } = await axios.put(`${URL}/arrangement/reject/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.REJECT_TRF,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: types.REJECT_TRF_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const reviewTRF = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.REVIEW_TRF_REQUEST,
        });
        const { data } = await axios.put(`${URL}/arrangement/review/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.REVIEW_TRF,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: types.REVIEW_TRF_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const declineTRF = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.DECLINE_TRF_REQUEST,
        });
        const { data } = await axios.put(`${URL}/arrangement/decline/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        
        dispatch({
            type: types.DECLINE_TRF,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: types.DECLINE_TRF_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};


export const acceptTRF = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.ACCEPT_TRF_REQUEST,
        });
        const { data } = await axios.put(`${URL}/arrangement/accept/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        dispatch({
            type: types.ACCEPT_TRF,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: types.ACCEPT_TRF_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};

export const unacceptTRF = (body) => async (dispatch) => {
    try {
        dispatch({
            type: types.UNACCEPT_TRF_REQUEST,
        });
        const { data } = await axios.put(`${URL}/arrangement/unaccept/${body.id}`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        
        dispatch({
            type: types.UNACCEPT_TRF,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: types.UNACCEPT_TRF_FAIL,
            payload:
                error && error.response && error.response.data.error
                    ? error.response.data.error
                    : error.request
                        ? error.request.data.error
                        : error.message,
        });
    }
};
